import React, { useEffect } from "react";

import { LEGAL_CONFIG } from "./legal-config";

type LegalPageProps = {
  title: string;
  lead: string;
  children: React.ReactNode;
};

export const LegalPage: React.FC<LegalPageProps> = ({ title, lead, children }) => {
  useEffect(() => {
    document.title = `${title} — ${LEGAL_CONFIG.serviceName}`;
  }, [title]);

  return (
    <article className="legal">
      <header className="legal__head">
        <p className="legal__eyebrow">Dokumenty</p>
        <h1 className="legal__title">{title}</h1>
        <p className="legal__lead">{lead}</p>
        <p className="legal__meta">
          Ostatnia aktualizacja: {LEGAL_CONFIG.lastUpdated}
        </p>
      </header>
      <div className="legal__body">{children}</div>
    </article>
  );
};

type LegalSectionProps = {
  id: string;
  number: string;
  title: string;
  children: React.ReactNode;
};

export const LegalSection: React.FC<LegalSectionProps> = ({
  id,
  number,
  title,
  children,
}) => {
  return (
    <section className="legal-section" id={id}>
      <h2 className="legal-section__title">
        <span className="legal-section__number">{number}</span>
        {title}
      </h2>
      {children}
    </section>
  );
};
